module.exports = __webpack_public_path__ + "static/media/sn_ab_bb2.a9e173c9.jpg";